export default __webpack_public_path__ + "static/media/Co_2020-7-1.2b2ca9b8.png";